import { render, staticRenderFns } from "./GatFooter.vue?vue&type=template&id=b75b103c&scoped=true&"
import script from "./GatFooter.vue?vue&type=script&lang=js&"
export * from "./GatFooter.vue?vue&type=script&lang=js&"
import style0 from "./GatFooter.vue?vue&type=style&index=0&id=b75b103c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75b103c",
  null
  
)

export default component.exports